import styled from "styled-components";

export const StyledFilesLinks = styled.div`
  padding-top: var(--spacing-md);
`;

export const StyledFilesBlock = styled.div`
  margin-bottom: var(--spacing-lg);
  h3 {
    font-size: var(--font-size-md);
    font-weight: 600;
    margin-bottom: var(--spacing-xs);
  }
`;

export const StyledFileItem = styled.div`
  margin-bottom: var(--spacing-sm);
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  a, span {
    cursor: pointer;
    color: var(--color-text);
    font-size: var(--font-size-md);
    font-weight: 400;
    text-decoration: underline;
  }
`;
